var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLicenece(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 36.6666C16.1388 35.6944 12.9513 33.4791 10.4375 30.0208C7.92357 26.5624 6.66663 22.7221 6.66663 18.4999V8.33325L20 3.33325L33.3333 8.33325V18.4999C33.3333 22.7221 32.0763 26.5624 29.5625 30.0208C27.0486 33.4791 23.8611 35.6944 20 36.6666ZM20 33.1666C22.8888 32.2499 25.2777 30.4166 27.1666 27.6666C29.0555 24.9166 30 21.861 30 18.4999V10.6249L20 6.87492L9.99996 10.6249V18.4999C9.99996 21.861 10.9444 24.9166 12.8333 27.6666C14.7222 30.4166 17.1111 32.2499 20 33.1666Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicenece);
export default __webpack_public_path__ + "static/media/licenece.c67633d627045a01d1be00ca25485187.svg";
export { ForwardRef as ReactComponent };